module.exports = __webpack_public_path__ + "img/GRAFIKA-NA-STRONE_1902x302_v3.3be5aff0.jpg";